import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { brand_channel_fields } from "../data";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";
import { arrType } from "data/globalData";

function BrandChannel({ value, setValue, disable, data }) {
	return (
		<Box p={0} width={"100%"}>
			<Box display="flex" flexWrap="wrap" columnGap={1} pl={2}>
				{brand_channel_fields?.map((row) => {
					let option_data = row.option_data ? row.option_data : {};
					if (row?.key === "store_brand") {
						option_data = {
							type: arrType,
							list: data["store_brand"],
						};
					}
					if (row?.key === "channel") {
						option_data = {
							type: arrType,
							list: data["channel"],
						};
					}
					return (
						<RenderInputField
							column={{ ...row, option_data }}
							data={value}
							setData={setValue}
							width="45%"
							selectOptObjName={"option_data"}
							key={row.key}
							disabled={disable}
						/>
					);
				})}
			</Box>
		</Box>
	);
}

export default BrandChannel;
